import { API_ENDPOINTS } from "./apiEndpoints";
import { useState, useEffect } from "react";
import { authenticatedFetch } from "./api";
import SearchableSelect from "./SearchableSelect";
import "./ShopifyConverter.css";

function CheckInventory() {
  const [vendor, setVendor] = useState("");
  const [vendors, setVendors] = useState([]);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ Fetch vendors from backend when component loads
  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const response = await authenticatedFetch(API_ENDPOINTS.vendors);
        if (!response.ok) throw new Error("Failed to load vendors");
        const data = await response.json();
        setVendors(data.vendors || []);
      } catch (err) {
        console.error("Error loading vendor list:", err);
      }
    };
    fetchVendors();
  }, []);

  const handleSubmit = async () => {
    if (!vendor || !file) {
      alert("Please select a vendor and upload a file.");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("vendor_name", vendor);
    formData.append("file", file);

    try {
      const response = await authenticatedFetch(API_ENDPOINTS.vendorUpdate, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Failed to check inventory.");

      const contentType = response.headers.get("content-type");

      if (contentType && contentType.includes("application/json")) {
        const data = await response.json();
        alert(data.message);
      } else {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${vendor}_new_rows.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error(error);
      alert("Error checking inventory. Check backend logs.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="converter-container">
      <h2>Inventory Checker</h2>

      <div className="form-group">
        <label>Vendor Name</label>
        <SearchableSelect
          options={vendors}
          value={vendor}
          onChange={(val) => setVendor(val)}
          placeholder="Select vendor..."
          disabled={loading}
        />
      </div>

      <div className="form-group">
        <label>Upload Inventory File</label>
        <input type="file" onChange={(e) => setFile(e.target.files[0])} />
      </div>

      <button onClick={handleSubmit} disabled={loading}>
        {loading ? "Processing..." : "Check Inventory"}
      </button>
    </div>
  );
}

export default CheckInventory;
